import "./tabs.scss";

import {
  Button,
  Card,
  CardBody,
  Col,
  FormGroup,
  Input,
  Label,
  Row,
} from "reactstrap";
import React, { useEffect, useState } from "react";
import {
  approveBeneficiaryById,
  sentConfirmationById,
} from "../../../../service/rak-beneficiary-service";
import {
  deleteUser,
  getTabBankDetailsList,
  getTabRakBeneficiaryList,
} from "../../../../service/profile-ras-service";
import {
  notificationStrings,
  openNotificationWithIcon,
} from "../../../../common/notification-message/notification";

import BankDetailsModal from "../modals/bankdetailsmodal";
import { DatePicker } from "antd";
import Loading from "../../../loader/loader.js";
import { Modal } from "react-bootstrap";
import NkTable from "../../nktable";
import RaKBeneficiaryFilter from "../modals/rakbeneficiary-filter";
import moment from "moment";

function DeleteConformation({
  setDeleteModal,
  deleteButtonloader,
  deleterakuser,
  beneficiaryid,
  show,
  onHide,
}) {
  return (
    <Modal
      // {...props}
      {...{ show }}
      {...{ onHide }}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className="common-modal"
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter"></Modal.Title>
      </Modal.Header>
      <Modal.Body>Are you sure, you want to delete ?</Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={() => setDeleteModal(false)}>
          No
        </Button>
        <Button
          variant="secondary"
          color="primary"
          disabled={deleteButtonloader}
          onClick={() => deleterakuser(beneficiaryid)}
        >
          {deleteButtonloader ? (
            <div style={{ display: "flex", justifyContent: "center" }}>
              <Loading color="white" width="20px" height="20px" />
            </div>
          ) : (
            "Yes"
          )}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

function SentConformation(props) {
  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className="common-modal"
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter"></Modal.Title>
      </Modal.Header>
      <Modal.Body>Are you sure, you want to send the confirmation ?</Modal.Body>
      <Modal.Footer>
        <Button
          variant="secondary"
          onClick={() => props.setshowConfirmation(false)}
        >
          No
        </Button>
        <Button
          variant="secondary"
          color="primary"
          disabled={props.loading}
          onClick={props.yesClicked}
        >
          {props.loading ? (
            <Loading color="white" width="15px" height="15px" />
          ) : (
            "Yes"
          )}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

const RakBeneficiariesTab = ({ userId }) => {
  const request = {
    page: 1,
    size: 10,
    beneficiaryName: null,
    receiver: null,
    fromDate: null,
    toDate: null,
    searchType: "",
    searchCountry: "",
    searchStatus: "",
    c3REF: null,
  };
  const [filterForm, setFilterForm] = useState(request);
  const [bankApproveLoading, setBankApproveLoading] = useState(false);
  const [deleteBeneficiaryLoader, setDeleteBeneficiaryLoader] = useState(false);
  const [rakTab, setRakTab] = useState([]);
  const [deleteButtonloader, setDeleteButtonloader] = useState(false);
  const [type, setType] = useState([]);
  const [country, setCountry] = useState([]);
  const [status, setStatus] = useState([]);
  const [confirmLoading, setConfirmLoading] = useState(false);
  const [pagination, setPagination] = useState({
    pageSize: 10,
    total: 0,
    current: 1,
  });

  const [showConfirmation, setshowConfirmation] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [bankModal, setBankModal] = useState(false);
  const [showFilterModal, setShowFilterModal] = useState(false);
  const [searchBy, setSearchBy] = useState("beneficiary");
  const [searchByValue, setSearchByValue] = useState("");
  const [filterValues, setFilterValues] = useState(false);
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState();
  const [dataLoading, setDataLoading] = useState(false);
  const [sizeShow, setSizeShow] = useState();
  const [bankrecordStatus, setBankrecordStatus] = useState("");
  const columns = [
    {
      dataField: "action",
      text: "Action",
      sort: false,
      headerStyle: { textAlign: "center" },
      style: { minWidth: "160px", textAlign: "center" },
      formatter: (cell, row) => {
        return (
          <div style={{ display: "flex", justifyContent: "center" }}>
            {/* <i
              className="ni ni-send"
              style={{ fontSize: 20 }}
              onClick={() => setshowConfirmation(true)}
            /> */}
            {row && row.status === "DELETING" ? null : (
              <>
                {row && row.status === "PENDING" ? (
                  <i
                    className="ni ni-send"
                    style={{ width: "25px", height: "15px", cursor: "pointer" }}
                    onClick={() => {
                      if (row && row.id) {
                        setBeneficiaryid(row.id);
                        setshowConfirmation(true);
                      }
                    }}
                  />
                ) : (
                  <div
                    className="ni"
                    style={{ width: "25px", height: "15px" }}
                  ></div>
                )}
                <i
                  className="fas fa-university"
                  style={{ width: "25%", height: "15px", cursor: "pointer" }}
                  onClick={() => {
                    if (row && row.id) {
                      console.log(row.id);
                      handleBankDetails(row.id);
                      setBankrecordStatus(row && row.recordStatus);
                    }
                  }}
                />
                <i
                  className="fas fa-trash-alt"
                  style={{ width: "25px", height: "15px", cursor: "pointer" }}
                  onClick={() => {
                    console.log(row);
                    if (row && row.id) {
                      setBeneficiaryid(row.id);
                      setDeleteModal(true);
                    }
                  }}
                />
              </>
            )}
          </div>
        );
      },
    },
    {
      dataField: "registrationDate",
      text: "Date",
      sort: true,
      style: { minWidth: "100px", textAlign: "Left" },
      formatter: (cell, row) => {
        return moment((row && row.createdDate) || null).format(
          "DD-MM-YY  HH:mm:ss"
        );
      },
    },
    {
      dataField: "beneficiary",
      text: "Beneficiary",
      sort: false,
      style: { minWidth: "150px", textAlign: "left" },
    },
    {
      dataField: "transfertype",
      text: "Type",
      sort: false,
      headerStyle: { textAlign: "left" },
      style: { minWidth: "150px", textAlign: "left" },
    },
    {
      dataField: "country",
      text: "Country",
      sort: false,
      style: { minWidth: "100px", textAlign: "center" },
      headerStyle: { textAlign: "center" },
    },

    {
      dataField: "status",
      text: "Status",
      sort: false,
      headerStyle: { textAlign: "left" },
      style: { minWidth: "150px", textAlign: "left" },
    },
  ];

  const [beneficiaryid, setBeneficiaryid] = useState();

  let searchByValuePlaceholder = "";
  if (searchBy === "beneficiary") {
    searchByValuePlaceholder = "Amit Pandit";
  } else {
    searchByValuePlaceholder = "Amit Pandit";
  }

  const [id, setId] = useState();

  useEffect(() => {
    if (userId) {
      setId(userId);
    }
  }, [userId]);

  useEffect(() => {
    if (id) {
      getTabRakBeneficiaryListDD(filterForm, id);
    }
  }, [id]);

  useEffect(() => {
    if (filterForm && filterForm.isFilter) {
      getTabRakBeneficiaryListDD(filterForm, id);
    }
  }, [filterForm]);

  const getTabRakBeneficiaryListDD = (request, id) => {
    setDataLoading(true);
    request["searchStatus"] =
      request.searchStatus.length == 0 ? "" : request.searchStatus;
    request["searchType"] =
      request.searchType.length == 0 ? "" : request.searchType;
    request["searchCountry"] =
      request.searchCountry.length == 0 ? "" : request.searchCountry;
    request.size = sizeShow || 10;
    getTabRakBeneficiaryList(request, id)
      .then((res) => {
        setDataLoading(false);
        setRakTab(res.data.moneyTransferBeneficiaries);
        setPagination({
          ...pagination,
          pageSize: sizeShow || 10,
          total: res.data.totalCount,
          current: request.page,
        });
      })
      .catch((err) => {
        setDataLoading(false);
        console.log(err);
        setRakTab([]); // TODO -NEED TO REMOVE
      });
  };

  const [bankDetails, setBankDetails] = useState([]);

  const handleBankDetails = (id) => {
    console.log(id);
    getTabBankDetailsList(id)
      .then((res) => {
        console.log(res.data);
        if (res && res.data && res.data.length > 0) {
          setBankDetails(res && res.data[0]);
          setBankModal(true);
        } else {
          // message.error("No bank details found");
          openNotificationWithIcon(
            notificationStrings.error,
            "No bank details found"
          );
        }
      })
      .catch((err) => {
        setBankDetails("");
        setBankModal(false);
      });
  };

  const handleFIlter = () => {
    let request = {};
    if (searchBy === "beneficiary") {
      request = {
        ...filterForm,
        beneficiaryName: searchByValue,
      };
    }
    if (filterForm.searchCountry && filterForm.searchCountry.length > 0) {
      let a = "";
      filterForm.searchCountry.forEach((v, i) => {
        console.log(v);
        a = a + v.value + (i + 1 < filterForm.searchCountry.length ? "," : "");
      });
      request.searchCountry = a || "";
    } else {
      request.searchCountry = filterForm.searchCountry || "";
    }

    if (filterForm.searchStatus && filterForm.searchStatus.length > 0) {
      let a = "";
      filterForm.searchStatus.forEach((v, i) => {
        console.log(v);
        a = a + v.value + (i + 1 < filterForm.searchStatus.length ? "," : "");
      });
      request.searchStatus = a || "";
    } else {
      request.searchStatus = filterForm.searchStatus || "";
    }

    if (filterForm.searchType && filterForm.searchType.length > 0) {
      let a = "";
      filterForm.searchType.forEach((v, i) => {
        console.log(v);
        a = a + v.value + (i + 1 < filterForm.searchType.length ? "," : "");
      });
      request.searchType = a || "";
    } else {
      request.searchType = filterForm.searchType || "";
    }
    request.fromDate =
      (fromDate && moment(fromDate).format("YYYY-MM-DD")) || null;
    request.toDate =
      (toDate && moment(toDate).format("YYYY-MM-DD")) || moment().format();
    request.searchFilter = "";
    request.page = 1;
    request.isFilter = true;

    setFilterForm(request);
  };
  const approveClicked = (id) => {
    console.log(id);
    setBankApproveLoading(true);
    approveBeneficiaryById(id)
      .then((res) => {
        setBankApproveLoading(false);
        // message.success("Beneficiary approved successfully");
        openNotificationWithIcon(
          notificationStrings.success,
          "Beneficiary approved successfully"
        );
        console.log({ res });
        getTabRakBeneficiaryListDD(filterForm, userId);
        setBankModal(false);
      })
      .catch((err) => {
        setBankApproveLoading(false);
        // message.error("Something went wrong");
        setBankModal(false);
      });
  };

  const deleteClicked = (id) => {
    setDeleteBeneficiaryLoader(true);
    deleteUser(id)
      .then((res) => {
        setDeleteBeneficiaryLoader(false);
        openNotificationWithIcon(
          notificationStrings.success,
          "User deleted successfully"
        );
        setBankModal(false);
        console.log({ res });
      })
      .catch((err) => {
        setDeleteBeneficiaryLoader(false);
        setBankModal(false);
        // message.error("Something went wrong");
      });
  };

  const confirmClicked = () => {
    console.log("Sent confirmation by id");
    setConfirmLoading(true);
    sentConfirmationById(beneficiaryid)
      .then((res) => {
        setConfirmLoading(false);
        console.log(res);
        setshowConfirmation(false);
        if (id) {
          getTabRakBeneficiaryListDD(filterForm, id);
        }
      })
      .catch((error) => {
        setConfirmLoading(false);
        setshowConfirmation(false);
        // message.error("Something went wrong");
        console.log(error);
      });
  };

  const deleterakuser = (id) => {
    setDeleteButtonloader(true);
    console.log("DELET GET PAYLOAD ::", filterForm);
    deleteUser(id)
      .then((res) => {
        setDeleteButtonloader(false);
        setDeleteModal(false);
        openNotificationWithIcon(
          notificationStrings.success,
          "Deleted successfully"
        );
        getTabRakBeneficiaryListDD(filterForm, userId);
      })
      .catch((err) => {
        setDeleteButtonloader(false);
        setDeleteModal(false);
        // openNotificationWithIcon(notificationStrings.error, err);
        console.log("ERROR MSG ::", err);
        // message.error("Something went wrong");
      });
  };

  const resetFilter = () => {
    request.isFilter = true;
    setType([]);
    setStatus([]);
    setCountry([]);
    setSearchBy("beneficiary");
    setSearchByValue("");
    setFilterForm(request);
    setFromDate("");
    setToDate("");
  };

  const clearFilter = () => {
    setFilterForm({
      ...filterForm,
      searchType: "",
      searchCountry: "",
      statusLength: 0,
      searchStatus: "",
      typeLength: 0,
      countryLength: 0,
      totalLength: 0,
    });
    setType([]);
    setStatus([]);
    setCountry([]);
  };

  const dateFormat = "DD-MM-YY";
  console.log("beneficiaryid", beneficiaryid);
  const customFormat = (value) => `${value.format(dateFormat)}`;
  return (
    <>
      <Row
        style={{ marginLeft: "0px", marginRight: "0px", padding: "12px 0px" }}
      >
        <Col lg="2" className="form-input-padding-tab">
          <FormGroup>
            <label
              className="form-control-label"
              htmlFor="exampleFormControlSelect1"
            >
              Search by
            </label>
            <Input
              id="exampleFormControlSelect1"
              style={{ height: "28px" }}
              type="select"
              value={searchBy}
              onChange={(e) => {
                setSearchByValue("");
                setSearchBy(e.target.value);
              }}
            >
              <option value="beneficiary">Beneficiary</option>
            </Input>
          </FormGroup>
        </Col>
        <Col lg="2" className="form-input-padding-tab">
          <FormGroup>
            <label className="form-control-label" htmlFor="example3cols2Input">
              Search for
            </label>
            <Input
              id="example3cols2Input"
              placeholder={searchByValuePlaceholder}
              type="text"
              style={{ height: "27px" }}
              onKeyPress={(e) => e.charCode === 13 && handleFIlter(true)}
              onChange={(e) =>
                setSearchByValue(
                  e.target && e.target.value && e.target.value.trim()
                )
              }
              value={searchByValue}
            />
          </FormGroup>
        </Col>
        <Col lg="2" className="form-input-padding-tab">
          <FormGroup>
            <Label className="form-control-label" htmlFor="example3cols2Input">
              From
            </Label>
            <DatePicker
              placeholder="DD-MM-YY"
              className="formcontrol-date"
              onChange={(e, dateString) => {
                if (dateString && dateString != "") {
                  setFromDate(moment(dateString, dateFormat));
                } else {
                  setFromDate(null);
                }
              }}
              value={fromDate}
              format={customFormat}
            />
          </FormGroup>
        </Col>
        <Col lg="2" className="form-input-padding-tab">
          <FormGroup>
            <Label className="form-control-label" htmlFor="example3cols2Input">
              To
            </Label>
            <DatePicker
              placeholder="DD-MM-YY"
              className="formcontrol-date"
              onChange={(e, dateString) => {
                if (dateString && dateString != "") {
                  setToDate(moment(dateString, dateFormat));
                } else {
                  setToDate(null);
                }
              }}
              value={toDate}
              format={customFormat}
            />
          </FormGroup>
        </Col>
        <div
          lg="1"
          className="form-input-padding-tab"
          style={{ marginTop: "2px" }}
        >
          <FormGroup>
            <Label
              className="form-control-label"
              htmlFor="exampleFormControlSelect1"
            >
              Filter by
            </Label>
            <div>
              <Button
                style={{ width: "100%", height: "26px" }}
                color="primary"
                type="button"
                id="example3cols2Input"
                className="filter-button"
                onClick={() => setShowFilterModal(true)}
              >
                <div>
                  {" "}
                  <i class="fas fa-filter"></i>
                </div>
              </Button>
            </div>
          </FormGroup>

          <span style={{ fontSize: 8 }}>
            {filterForm && filterForm.totalLength > 0 ? (
              <>
                <h6 style={{ display: "flex", alignItems: "center" }}>
                  selected(
                  {filterForm.totalLength}
                  )
                  <i
                    class="fas fa-window-close"
                    style={{ cursor: "pointer", paddingLeft: "5px" }}
                    onClick={() => clearFilter()}
                  />
                </h6>
              </>
            ) : (
              <></>
            )}
          </span>
        </div>
        <Col
          lg="1"
          style={{ marginTop: "9px" }}
          className="form-input-padding-tab"
        >
          <FormGroup>
            <Label
              className="form-control-label"
              htmlFor="example3cols2Input"
            ></Label>
            <div>
              <Button
                type="button"
                style={{
                  width: "100%",
                  background: "#e91d24",
                  color: "white",
                  height: "26px",
                  border: "1px solid rgb(233, 29, 36)",
                }}
                id="example3cols2Input"
                className="filter-button"
                onClick={() => handleFIlter()}
              >
                <div>
                  <i class="fas fa-search"></i>
                </div>
              </Button>
            </div>
          </FormGroup>
        </Col>
        <Col
          lg="1"
          style={{ marginTop: "9px" }}
          className="form-input-padding-tab"
        >
          <FormGroup>
            <Label
              className="form-control-label"
              htmlFor="example3cols2Input"
            ></Label>
            <div>
              <Button
                color="light"
                type="button"
                style={{ width: "100%", height: "26px" }}
                id="example3cols2Input"
                className="filter-button"
                onClick={() => resetFilter()}
              >
                <div
                  style={{
                    fontSize: "12px",
                  }}
                >
                  {" "}
                  <i class="fas fa-redo-alt 2px"></i> Reset
                </div>
              </Button>
            </div>
          </FormGroup>
        </Col>
      </Row>
      {rakTab.length < 0 ? (
        <>
          <Card
            className="mb-4"
            style={{
              display: "flex",
              flex: 1,
              textAlign: "center",
              justifyContent: "center",
              padding: "1.25rem 1.5rem",
            }}
          >
            <CardBody>
              <h3 className="mb-0">No Records Found</h3>
              {/* <h3 className="mb-0">
                  Enter a different search term or remove any filters and try
                  again
                </h3> */}
            </CardBody>
          </Card>
        </>
      ) : (
        <>
          <Row style={{ padding: "1.25rem 0.5rem" }}>
            <div className="col card-parent">
              <Card>
                {dataLoading ? (
                  <div style={{ textAlign: "center" }}>
                    <Loading />
                  </div>
                ) : (
                  <>
                    <NkTable
                      filename={"All-User-List"}
                      data={rakTab}
                      columns={columns}
                      pagination={pagination}
                      onPagechange={(page) => {
                        setFilterForm({
                          ...filterForm,
                          page: page,
                          isFilter: true,
                        });
                      }}
                      showSizeChanged={(pageSize) => {
                        setSizeShow(pageSize);
                        setFilterForm({
                          ...filterForm,
                          isFilter: true,
                        });
                      }}
                    />
                  </>
                )}
              </Card>
            </div>
          </Row>
        </>
      )}
      <RaKBeneficiaryFilter
        show={showFilterModal}
        type={type}
        country={country}
        setCountry={setCountry}
        setStatus={setStatus}
        status={status}
        setType={setType}
        onHide={() => {
          setShowFilterModal(false);
        }}
        saveButtonClicked={(saveResponse) => {
          setFilterForm({ ...filterForm, ...saveResponse, isFilter: false });
          setShowFilterModal(false);
        }}
      />
      <BankDetailsModal
        show={bankModal}
        setBankApproveLoading={setBankApproveLoading}
        bankApproveLoading={bankApproveLoading}
        onHide={() => setBankModal(false)}
        approveClicked={(e) => approveClicked(e)}
        deleteClicked={(e) => deleteClicked(e)}
        deleteBeneficiaryLoader={deleteBeneficiaryLoader}
        bankDetails={bankDetails}
        rakTab={rakTab}
        bankrecordStatus={bankrecordStatus}
      />
      <SentConformation
        show={showConfirmation}
        onHide={() => setshowConfirmation(false)}
        setshowConfirmation={setshowConfirmation}
        yesClicked={() => confirmClicked()}
        loading={confirmLoading}
      />
      <DeleteConformation
        show={deleteModal}
        onHide={() => setDeleteModal(false)}
        {...{
          setDeleteModal,
          deleteButtonloader,
          deleterakuser,
          beneficiaryid,
        }}
      />
    </>
  );
};
export default RakBeneficiariesTab;
